import { addToChainAfter } from "@insite/client-framework/HandlerCreator";
import {
    chain,
    PopulateApiParameter,
    SetCartStatus,
} from "@insite/client-framework/Store/Pages/CheckoutReviewAndSubmit/Handlers/PlaceOrder";
import { CustomState } from "@waytek/Store/Reducers";

addToChainAfter(chain, SetCartStatus, props => {
    props.cartToUpdate.cartLines = props.cartToUpdate.cartLines?.map(cl => ({
        ...cl,
        notes: cl.notes.slice(0, (props.parameter as any).notesMaxNumberOfCharacters ?? 28).trim(),
    }));
});

addToChainAfter(chain, PopulateApiParameter, props => {
    const {
        checkoutReviewAndSubmit: { shipOrderComplete },
    } = props.getState() as CustomState;

    if (shipOrderComplete) {
        props.apiParameter = {
            cart: {
                ...props.cartToUpdate,
                properties: {
                    ...props.cartToUpdate.properties,
                    shipOrderComplete: `${shipOrderComplete}`,
                },
            },
        };
    }
});
